module.exports = __webpack_public_path__ + "static/img/pcbanner.7d5cf92.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/pcbanner.png
// module id = Fjv7
// module chunks = 2